// ============================================================================
// GsKpiComparison — KPI « valeur héros + deltas de comparaison » (MASTER-GEST-E1A)
// ============================================================================
// Distinct de KpiCard (stat simple icône+valeur, qui RESTE pour ces cas) : ici
// une valeur héros text-kpi (ROUGE si négative — règle « négatif → red-600 »)
// accompagnée de N deltas de comparaison (▲/▼ + libellé « budget », « an.
// préc. »). Bloc de CONTENU (sans coque de carte) : l'appelant le compose dans
// sa carte (ex. carte « Indicateurs » du rail accueil gest, avec sa bande de
// cellules stat secondaires — qui ne sont PAS sur-componentisées ici).
// Valeurs/libellés déjà formatés par l'appelant (i18n + Intl par props — JAMAIS
// de t() dans @gs/ui). Poids des chiffres = font-bold, jamais plus lourd (§4c).
// Tokens + échelle nommée uniquement (règle #28) — zéro hex, zéro text-[Npx].

export interface GsKpiComparisonDelta {
  /** Valeur déjà formatée (« 12,8 % »). */
  value: string;
  /** Libellé de comparaison déjà traduit (« budget », « an. préc. »). */
  label: string;
  direction: 'up' | 'down';
  /** Delta favorable → vert (défaut) ; défavorable → rouge. */
  favorable?: boolean;
}

export interface GsKpiComparisonProps {
  /** Libellé du KPI déjà traduit (« Revenu du mois »). */
  label: string;
  /** Valeur héros déjà formatée (« 2 345 782 $ »). */
  value: string;
  /** Valeur négative → text-red-600 (règle couleur UI_STANDARDS §4). */
  negative?: boolean;
  deltas?: GsKpiComparisonDelta[];
  className?: string;
}

/** KPI héros + deltas de comparaison — la valeur porte la couleur, le delta le sens. */
export function GsKpiComparison({
  label,
  value,
  negative = false,
  deltas = [],
  className = '',
}: GsKpiComparisonProps) {
  return (
    <div className={className}>
      <p className="text-meta font-medium text-slate-500 dark:text-slate-400">{label}</p>
      <p
        className={`mt-1 text-kpi font-bold leading-none tabular-nums ${
          negative ? 'text-red-600 dark:text-red-400' : 'text-slate-800 dark:text-slate-100'
        }`}
      >
        {value}
      </p>
      {deltas.length > 0 && (
        <p className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-meta">
          {deltas.map((d, i) => (
            <span key={`${d.label}-${i}`} className="inline-flex items-baseline gap-1">
              <span
                className={`inline-flex items-baseline gap-0.5 font-semibold tabular-nums ${
                  d.favorable === false
                    ? 'text-red-600 dark:text-red-400'
                    : 'text-green-700 dark:text-green-500'
                }`}
              >
                <span aria-hidden className="text-chip leading-none">
                  {d.direction === 'up' ? '▲' : '▼'}
                </span>
                {d.value}
              </span>
              <span className="font-medium text-slate-400 dark:text-slate-500">{d.label}</span>
            </span>
          ))}
        </p>
      )}
    </div>
  );
}
